module.exports = __webpack_public_path__ + "assets/Zeta.3ca68dc938252d5d3276138c81c5bd96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Zeta.png
// module id = 851
// module chunks = 0